module.exports = __webpack_public_path__ + "media/images/icons/client_relations-65352586b0d42faefc2a3349e86c79fe.svg";